<template>
    <table class="table table-hover bg-alt-yellow rounded my-3">
        <thead>
            <tr>
                <th scope="col">Event</th>
                <th>Location</th>
                <th>Start</th>
                <th>End</th>
                <th>Actions</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="event in events">
                <td><span>{{ event.name }}</span></td>
                <td><span>{{ event.location }}</span></td>
                <td><span v-text="this.Timestamp(event.start_date)"></span></td>
                <td><span v-text="this.Timestamp(event.end_date)"></span></td>
                <td>
                    <button class="btn btn-warning" type="button"><a :href="`/admin/event/edit/${ event.id }}`">Edit</a></button>
                    <button v-if="this.filter == 'active'" @click="this.Delete(event.id)" class="btn btn-warning mx-2" type="button">Delete</button>
                    <button v-if="this.filter == 'deleted'" @click="this.Restore(event.id)" class="btn btn-warning mx-2" type="button">Restore</button>
                    <button v-if="event.type == 'altlan'" class="btn btn-warning ml-1" type="button"><a :href="`/admin/event/tickets/${ event.id }`">Tickets Sold</a></button>
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script>

import moment from 'moment';

export default {

    data () {
        return {
            events: []
        }
    },

    created () {
        this.events = this.items;
    },

    methods: {
        Timestamp ( date ) {
            return moment(date).format('MMMM Do YYYY, hh:mm a');
        },

        async Delete ( id ) {
		    const response = await axios.post(`/admin/event/delete`, { id: id });
            const key = this.events.findIndex(a => a.id == id);
            this.events.splice(key, 1);
  		    window.Toast("Event Has Been Deleted");
	    },

	    async Restore ( id ) {
		    const response = await axios.post(`/admin/event/restore`, { id: id });
            const key = this.events.findIndex(a => a.id == id);
            this.events.splice(key, 1);
  		    window.Toast("Event Has Been Restored");
	    }

    },

    components: {

    },

    props: ['items', 'filter'],

}
</script>